import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { App } from "antd";
import { VENTAS, LOADING_VENTAS } from "../store/selectors";
import { setLoading, setVentas } from "../store/slices/ventas";
import { getPedidos } from "../services/ventas/ventas.service";

export const useVentas = (schoolId?: number) => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const ventas = useSelector(VENTAS);
  const loading = useSelector(LOADING_VENTAS);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      const data = await getPedidos(schoolId);
      dispatch(setVentas(data));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification.error({
        message: "Error",
        description: "No se pudieron cargar los pedidos.",
        placement: "top",
        duration: 3,
      });
    }
  };

  useEffect(() => {
    fetchInfo();
  }, [schoolId]);

  return {
    loading,
    ventas,
  };
};
